import {
  lowercaseCount,
  numbersCount,
  specialCharsCount,
  uppercaseCount,
} from './string-validators';

export const passwordValidator = (value: string) => {
  const errors: any = [];
  if (value.length < 10) {
    errors.push('length');
  }
  if (lowercaseCount(value) < 1) {
    errors.push('lowercase');
  }
  if (uppercaseCount(value) < 1) {
    errors.push('uppercase');
  }
  if (numbersCount(value) < 1) {
    errors.push('numbers');
  }
  if (specialCharsCount(value) < 1) {
    errors.push('specialChars');
  }
  return errors.length > 0 ? errors.join(':') : null;
};

export const confirmPasswordValidator = (value: string, compareTo: string) => {
  const error: any = {};
  if (value !== compareTo || value.length === 0) {
    error.noMatch = true;
  }
  return Object.keys(error).length !== 0 ? error : null;
};
